<template>
  <div class="banner_wrap">
    <div v-if="top" class="buy_limit">
      <div class="limit_detail" v-if="formatBuyLimit"> {{ formatBuyLimit }} </div>
      <div class="limit_detail" v-if="formatChargeAmount"> {{ formatChargeAmount }} </div>
      <div class="limit_detail" v-if="formatUserSave"> {{ formatUserSave }} </div>
      <div class="limit_detail" v-if="formatMaxPoint"> {{ formatMaxPoint }} </div>
    </div>
    <div
      class="banner_base"
      :class="{detail_show: showDetail , 'shine-effect': (top && !isCountdown && packItem.pack_count > 0 && false)}"
      @click="handleShowDetail(packItem)"
    >
      <div
        :class="['product-banner', {'active': isActive, 'detail': showDetail }, {'multi': imageCount > 1}]"
        :style="{ ...dotsStyleVariables, '--animation-duration': `${animationDuration}ms` }"
        >
        <div class="image_area">
          <div
          class="image"
          >
            <img
              class="current"
              :src="currentImage"
              @animationend="setCurrentImageIndex(animationDelay)"
            />
            <img
              class="next"
              :src="nextImage"
            />
            <div v-if="top" class="gacha_pay">
              <img class="coin" src="/img/dorima-icon-coin.png" alt="">
              <div >{{ packItem.point | comma }}</div>
            </div>
          </div>
        </div>
        <div
          v-if="nextImage"
          class="image next"
          :style="{backgroundImage: `url(${nextImage})`}"
        />
      </div>
      <div class="button_area" v-if="!showDetail">
        <div class="name_area">
          <div class="gacha_content">
            <div class="buy_rank">
              <img class="rank_icon" :class="{'all' : isAllBadge }" v-if="packItem.badges.includes('white') || isAllBadge " src="/img/rank/1.png" alt="">
              <img class="rank_icon" :class="{'all' : isAllBadge }" v-if="packItem.badges.includes('bronze') || isAllBadge" src="/img/rank/2.png" alt="">
              <img class="rank_icon" :class="{'all' : isAllBadge }" v-if="packItem.badges.includes('silver') || isAllBadge" src="/img/rank/3.png" alt="">
              <img class="rank_icon" :class="{'all' : isAllBadge }" v-if="packItem.badges.includes('gold') || isAllBadge" src="/img/rank/4.png" alt="">
              <img class="rank_icon" :class="{'all' : isAllBadge }" v-if="packItem.badges.includes('rainbow') || isAllBadge" src="/img/rank/5.png" alt="">
              <img class="rank_icon" :class="{'all' : isAllBadge }" v-if="packItem.badges.includes('black') || isAllBadge" src="/img/rank/6.png" alt="">
              <img class="rank_icon" :class="{'all' : isAllBadge }" v-if="packItem.badges.includes('eternal_black') || isAllBadge" src="/img/rank/7.png" alt="">
            </div>
            <div class="limit_message" v-if="packItem.can_limit === 1">
              {{ packItem.limit_message }}
            </div>
            <div class="buy_area">
              <SelectBox
              :class="{'disabled' : !remainingBuyCount }"
              class="select_box"
              :options="buyList"
              selectedOption="1"
              :isSmall="true"
              @handleSelectChange="changeCount"
              />
              <BuyButton
              class="purchase-btn"
              :isArrow="false"
              @handleSquareBtnClick="handleBuyClick(packItem)"
              />
            </div>
            <div class="gacha_bar">
              <div class="">{{ t('残数') }}
                <br v-if="packItem.pack_count >= 1000 || packItem.total_pack_count >= 1000" />
                {{ packItem.pack_count | comma }} / {{ packItem.total_pack_count | comma }}</div>
              <GachaBarGraph
                :maxValue="packItem.total_pack_count"
                :currentValue="packItem.pack_count"
              />
            </div>
            <div class="end-date">
              {{ formattedSaleText }}
            </div>
          </div>
          <div class="countdown" v-if="isCountdown">
            <span class="label_title">{{ t('販売開始まで') }}</span>
            <span :class="isLongCountdown ? 'num days-font' : 'num timer-font'">{{countdownStr}}</span>
          </div>
          <div class="sold_out" v-if="packItem.pack_count == 0"><span>SOLD OUT</span></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  separateCharacterNumber,
} from '@/common/util/format';
import t from '@/plugins/i18n';
import GachaBarGraph from '@/components/atoms/GachaBarGraph.vue';
import BuyButton from '@/components/atoms/BuyButton.vue';
import SelectBox from '@/components/atoms/SelectBox.vue';

export default {
  name: 'ProductBanner',

  components: {
    GachaBarGraph,
    BuyButton,
    SelectBox,
  },
  mixins: [t],

  filters: {
    comma(value) {
      return separateCharacterNumber(value);
    },
  },

  props: {
    packItem: {
      type: Object,
      default: () => {},
    },
    showDetail: {
      type: Boolean,
      default: false,
    },
    currentUser: {
      type: Object,
    },
    isTitle: {
      type: Boolean,
      default: false,
    },
    top: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    currentImageIndex: null,
    nextImageIndex: null,
    isActive: false,
    animationDelay: 2000,
    animationDuration: 1000,
    timer: null,
    isCountdown: false,
    countdownStr: '',
    setTimerID: null,
    count: 1,
  }),

  computed: {
    isAllBadge() {
      return Array.isArray(this.packItem?.badges) && this.packItem.badges.includes('all');
    },
    currentImage() {
      if (this.packItem && this.packItem.image && this.currentImageIndex !== null) {
        return this.packItem.image[this.currentImageIndex];
      }
      return null;
    },
    nextImage() {
      if (this.packItem && this.packItem.image && this.nextImageIndex !== null) {
        return this.packItem.image[this.nextImageIndex];
      }
      return null;
    },
    imageCount() {
      if (this.packItem && this.packItem.image) {
        return this.packItem.image.length;
      }
      return 0;
    },
    dotsStyleVariables() {
      if (this.imageCount > 0) {
        const dotWidth = 7;
        const dotHeight = 7;
        const dotMargin = 10;
        const dotsWidth = this.imageCount * (dotWidth + dotMargin) - dotMargin;
        return {
          '--dot-width': `${dotWidth}px`,
          '--dot-height': `${dotHeight}px`,
          '--dot-margin': `${dotMargin}px`,
          '--dots-width': `${dotsWidth}px`,
        };
      }
      return null;
    },
    remainingBuyCount() {
      // 購入制限がある場合の残り回数チェック
      const maxBuyCount = parseInt(this.packItem.max_buy_count, 10);
      const remainingBuyCount = parseInt(this.packItem.buy_count, 10);
      // 購入制限があり、残り回数が0の場合は選択肢を空にする
      if (maxBuyCount > 0 && remainingBuyCount === 0) {
        return false;
      }
      return true;
    },
    buyList() {
      if (!this.packItem.pack_count) {
        return [];
      }
      let count = 0;
      try {
        count = parseInt(this.packItem.pack_count.replace(',', ''), 10);
      } catch (error) {
        count = parseInt(this.packItem.pack_count, 10);
      }
      let max = count;
      if (max > 3000) {
        max = 3000;
      }
      const maxCount = parseInt(this.packItem.buy_count, 10);
      if (maxCount > 0 && max > maxCount) {
        max = maxCount;
      }
      const option = [];
      for (let i = 1; i <= max; i += 1) {
        option.push({ id: i, name: i });
      }
      return option;
    },
    formattedSaleText() {
      const dateText = this.packItem.end_date;
      if (!dateText) return '';
      const date = new Date(dateText.replace(/-/g, '/'));
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const key = '{year}/{month}/{day} まで販売';
      const lang = this.currentUser?.language;
      const template = this.i18n_message?.[key]?.[lang] || key;
      return template
        .replace('{year}', year)
        .replace('{month}', month)
        .replace('{day}', day);
    },
    formatBuyLimit() {
      const count = this.packItem.max_buy_count;
      if (count === 0) {
        return null;
      }
      const lang = this.currentUser?.language || 'ja'; // 言語設定（必要に応じて変更）
      if (this.packItem.buy_limit_time) {
        const dailyKey = '1日%d回限定';
        const dailyTemplate = this.i18n_message?.[dailyKey]?.[lang];
        if (dailyTemplate) {
          return dailyTemplate.replace('%d', count);
        }
        return `1日${count}回限定`;
      }
      // 通常の「%d回限定」
      const key = '%d回限定';
      const template = this.i18n_message?.[key]?.[lang] || key;
      if (template) {
        return template.replace('%d', count);
      }

      return `${count}回限定`;
    },
    isLongCountdown() {
      return !this.countdownStr.includes('.');
    },
    formatChargeAmount() {
      const amount = this.packItem.min_charge_amount;
      if (!amount) return null;

      const lang = this.currentUser?.language || 'ja';
      const key = '今月{amount}ポイント以上決済された方限定';
      const template = this.i18n_message?.[key]?.[lang] || key;

      return template.replace('{amount}', separateCharacterNumber(amount));
    },
    formatUserSave() {
      const dateText = this.packItem.user_save_date;
      const mode = this.packItem.savedate_mode;
      // console.log('mode', mode);
      // console.log('dateText', dateText);
      if (!dateText || !mode) return null;
      const date = new Date(dateText.replace(/-/g, '/'));
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const lang = this.currentUser?.language || 'ja';
      const key1 = '{year}/{month}/{day} 以前の登録';
      const key2 = '{year}/{month}/{day} 以降の登録';
      const template = mode === 1 ? this.i18n_message?.[key1]?.[lang] || key1 : this.i18n_message?.[key2]?.[lang] || key2;
      return template
        .replace('{year}', year)
        .replace('{month}', month)
        .replace('{day}', day);
    },
    formatMaxPoint() {
      const amount = this.packItem.max_point_limit;
      if (!amount) return null;
      const lang = this.currentUser?.language || 'ja';
      const key = '所持{amount}ポイント以下の方限定';
      const template = this.i18n_message?.[key]?.[lang] || key;
      return template.replace('{amount}', separateCharacterNumber(amount));
    },
  },

  mounted() {
    this.$nextTick(() => {
      if ('image' in this.packItem) {
        this.currentImageIndex = 0;
        // 画像が2枚以上ある場合、次の画像indexをセットする。
        if (this.packItem.image.length > 1) {
          this.setNextImageIndex();
        }
      }
    });

    // const day1 = new Date(this.packItem.start_date);
    // const day2 = new Date();
    // const diffDay = day1 - day2;
    if (this.packItem.is_before) {
      this.isCountdown = true;
      this.setTimerID = setInterval(() => {
        this.setCountdownString();
      }, 1000);
      this.setCountdownString();
    }
  },

  beforeDestroy() {
    // タイマーをクリーンアップ
    if (this.setTimerID) {
      clearInterval(this.setTimerID);
    }
    if (this.timer) {
      clearTimeout(this.timer);
    }
  },

  methods: {
    setCountdownString() {
      // const day1 = new Date(this.packItem.start_date.replace(/-/g, '/'));
      const day1 = new Date(`${this.packItem.start_date.replace(/-/g, '/')} +09:00`);
      const day2 = new Date();
      const diffTime = day1 - day2;
      const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

      if (diffTime < 0) {
        this.isCountdown = false;
        clearInterval(this.setTimerID);
        return;
      }
      const lang = this.currentUser?.language || 'ja';
      // 72時間以上（3日以上）の場合は「販売開始までX日」
      if (diffTime > 72 * 60 * 60 * 1000) {
        const key = '%d日';
        const template = this.i18n_message?.[key]?.[lang] || key;
        this.countdownStr = template.replace('%d', diffDays);
      } else {
        // 72時間未満（HH:MM:SSのカウントダウン）
        const h = `0${Math.floor(diffTime / (1000 * 60 * 60))}`.slice(-2);
        const m = `0${Math.floor((diffTime % (1000 * 60 * 60)) / (1000 * 60))}`.slice(-2);
        const s = `0${Math.floor((diffTime % (1000 * 60)) / 1000)}`.slice(-2);
        this.countdownStr = `${h}.${m}.${s}`;
      }
    },
    handleBannerClick(packId) {
      this.$router.push({ path: '/pack-detail', query: { packId } });
      this.$emit('handleBannerClick', (packId));
    },
    handleLoginClick() {
      this.$emit('handleLoginClick');
    },
    handleBuyClick(packItem) {
      this.$emit('handleBuyClick', packItem, this.count);
    },
    setCurrentImageIndex(animationDelay = this.animationDelay, imageIndex = null) {
      // imageIndexが明示的に渡された時は渡された値にimageIndexを変更する
      if (imageIndex !== null) {
        this.currentImageIndex = imageIndex;
      } else if (imageIndex === null && this.currentImageIndex === this.imageCount - 1) {
        // if (this.currentImageIndex === this.imageCount - 1) {
        this.currentImageIndex = 0;
      } else {
        this.currentImageIndex += 1;
      }
      setTimeout(() => {
        this.changeIsActive(false);
        // this.isActiveがfalseになり画面が際レンダリングされてから呼び出す。
        this.$nextTick(() => {
          this.setNextImageIndex(animationDelay);
        });
      }, 500);
    },
    setNextImageIndex(animationDelay = this.animationDelay) {
      // アニメーションを開始する
      this.timer = setTimeout(() => {
        this.changeIsActive(true);
      }, animationDelay);
      // 現在の画像が配列の末尾のものの場合
      if (this.currentImageIndex === this.imageCount - 1) {
        this.nextImageIndex = 0;
      } else {
        this.nextImageIndex = this.currentImageIndex + 1;
      }
    },
    changeIsActive(status) {
      this.isActive = status;
    },
    showPrevImage() {
      // アニメーション中は何もしない
      if (this.isActive) {
        return;
      }
      if (this.timer) {
        clearTimeout(this.timer);
      }
      if (this.currentImageIndex === 0) {
        this.currentImageIndex = this.imageCount - 1;
      } else {
        this.currentImageIndex -= 1;
      }
      this.changeIsActive(false);
      // this.isActiveがfalseになり画面が際レンダリングされてから呼び出す。
      this.$nextTick(() => {
        this.setNextImageIndex(this.animationDelay);
      });
    },
    showNextImage() {
      // アニメーション中は何もしない
      if (this.isActive) {
        return;
      }
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.setCurrentImageIndex(this.animationDelay);
    },
    showSelectImage(imageIndex) {
      // アニメーション中は何もしない
      if (this.isActive) {
        return;
      }
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.setCurrentImageIndex(this.animationDelay, imageIndex);
    },
    handleShowDetail(packItem) {
      if (this.isCountdown) {
        return;
      }
      if (packItem.card_hide_flag === 1 && Number(packItem.pack_count) !== 0) {
        this.$emit('handleCardHide');
        return;
      }
      if (packItem.pack_count === 0) {
        return;
      }
      if (packItem.pack_count === '0') {
        return;
      }
      // if (this.currentUser.is_login === '0') {
      //   this.handleLoginClick();
      // } else if (packItem.pack_count > 0) {
      this.handleBannerClick(packItem.id);
      // }
    },
    changeCount(val) {
      this.count = parseInt(val, 10);
    },
  },

};
</script>

<style lang="scss" scoped>
$shadowBtnHeight: 77px;
.banner_wrap{
  width: 50%;
  min-width: 285px;
  border-radius: 10px;
  position: relative;
  display: flex;
  cursor: pointer;
  .buy_limit{
    position: absolute;
    top: -16px;
    left: 10px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    .limit_detail{
      box-shadow: 0 0 5px rgba(0, 0, 0, 0.7);
      background: white;
      margin: 0 4px 2px 0;
      padding: 2px 5px;
      border-radius: 5px;
      z-index: 2;
      font-weight: bold;
      color: $mainColor;
      @media screen and (max-width: $tabletWidth) {
        font-size: 9px;
      }
    }
  }
  .banner_base {
    width: 100%;
    border-radius: 10px;
    box-shadow: 0 0 15px rgba(0, 0, 0, 0.7);
    display: flex;
    &.shine-effect {
      position: relative;
      overflow: hidden;
      &::before {
        content: "";
        position: absolute;
        top: 0;
        left: -75%;
        width: 50%;
        z-index: 5;
        height: 100%;
        background: linear-gradient(
          to right,
          rgba(255, 255, 255, 0) 0%,
          rgba(255, 255, 255, 0.6) 50%,
          rgba(255, 255, 255, 0) 100%
        );
        transform: skewX(-20deg);
        animation: shine 2.5s infinite;
      }
      @keyframes shine {
        0% {
          left: -75%;
        }
        100% {
          left: 125%;
        }
      }
    }
    .product-banner {
      &.detail {
        background-image: none;
        margin-bottom: 0!important;
        .image_area {
          height: 100%;
          width: 100%;
          .image {
            height: 100%;
            width: 100%;
            margin-bottom: 0!important;
          }
        }
      }
    }
  }
}
.product-banner{
  width: 60%;
  position: relative;
  .image_area{
    width: 100%;
    height: 100%;
    // aspect-ratio: 5 / 3;
    .image{
      width: 100%;
      height: 100%;
      position: relative;
      border-radius: 10px;
      box-shadow: 15px 0 15px -5px rgba(0, 0, 0, 0.3);
      .gacha_pay {
        font-size: 16px;
        position: absolute;
        bottom: 10px;
        right: 0px;
        background: rgba(255, 255, 255); // 半透明背景
        display: flex;
        align-items: center;
        padding: 4px 8px;
        border-radius: 20px 0 0 20px;
        font-weight: bold;
        .coin{
          width: 24px;
        }
      }
      .current{
        opacity: 1;
        height: 100%;
        width: 100%;
        border-radius: 10px;
        vertical-align: top;
      }
      .next{
        opacity: 0;
        position: absolute;
        border-radius: 10px;
        height: 100%;
        width: 100%;
        top: 0;
        left: 0;
      }
    }
  }
  .btn{
    position: absolute;
    height: $shadowBtnHeight;
    top: calc(50% - #{$shadowBtnHeight}/2);
    z-index: 1;
    cursor: pointer;
    &.prev{
      left: 8px;
    }
    &.next{
      right: 4px;
    }
  }
  .dots{
    position: absolute;
    left: calc(50% - (var(--dots-width) / 2));
    bottom: -21px;
    display: flex;
    .dot{
      width: var(--dot-width);
      height: var(--dot-height);
      background-color: $white;
      border-radius: 100%;
      border: solid 1px $yellow;
      & + .dot{
        margin-left: var(--dot-margin);
      }
      &.active{
        background: $yellow;
      }
    }
  }
  &.active{
    .image{
      .current{
        animation-name: fadeOut;
        animation-duration: var(--animation-duration);
        animation-timing-function: ease-in;
        animation-delay: 0s;
        animation-iteration-count: 1;
        animation-direction: normal;
        animation-fill-mode: forwards;
      }
      .next{
        animation-name: fadeIn;
        animation-duration: var(--animation-duration);
        animation-timing-function: ease-in;
        animation-delay: 0s;
        animation-iteration-count: 1;
        animation-direction: normal;
        animation-fill-mode: forwards;
      }
    }
  }
  // &.multi {
  //   margin-bottom: 15px;
  // }

  .point_area {
    .pack_point {
      position: absolute;
      top: 10px;
      left: 10px;
      background-color: #000;
      border-radius: 100px;
      color: $white;
      padding: 4px 10px;
      min-width: 90px;
      text-align: center;
      z-index: 1;
    }
  }
}
.pack_area {
  margin-top: 30px;
  .pack_name {
    margin-bottom: -15px;
  }
}
.sold_out {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding-bottom: 0%;
  background-color: rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: center;
  align-items: center;
  color: $white;
  font-size: 80px;
  border-radius: 8px;
  span{
    border-radius: 8px;
    padding: 5px 20px;
    font-weight: bold;
    transform: rotate(15deg);
    text-shadow: 4px 4px 4px rgba(0, 0, 0, 0.5);
  }
}
.countdown {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding-bottom: 0%;
  background-color: rgba(255, 255, 255, 0.7);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  span.num {
    color: #FF8C00;
    background: $mainColor;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    &.timer-font{
      font-family: seven-segment!important;
      font-size: 37px;
    }
    &.days-font{
      font-size: 28px;
    }
  }
  span.label_title {
    font-size: 12px;
    font-weight: bold;
    margin-bottom: 10px;
    color: $black;
  }
}
.button_area {
  width: 40%;
  .name_area {
    display: flex;
    margin: 0 15px;
    color: #6d6c6c;
    font-weight: bold;
    height: 100%;
    .gacha_content {
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      height: 100%;
      width: 100%;
      .buy_rank{
        display: flex;
        justify-content: center;
        .rank_icon{
          width: 30px;
          height: auto;
          margin: 5px 0 0 5px;
            @media screen and (max-width: 1100px) {
              width: 23px;
            }
          @media screen and (max-width: 870px) {
              width: 17px;
            }
            @media screen and (max-width: 680px) {
              width: 27px;
            }
            @media screen and (max-width: $mobileWidth) {
              width: 18px;
            }
          &.all {
            width: 30px;
            @media screen and (max-width: 1100px) {
              width: 19px;
            }
            @media screen and (max-width: 870px) {
              width: 15px;
            }
            @media screen and (max-width: 680px) {
              width: 20px;
            }
            @media screen and (max-width: $mobileWidth) {
              width: 15px;
            }
          }
        }
      }
      .limit_message {
        width: auto;
        max-width: 100%;
        font-size: 11px;
        text-align: center;
        color: red;
        line-height: 1.2;
        @media screen and (min-width: 1000px) {
          font-size: 14px;
        }
      }
      .gacha_bar {
        font-size: clamp(10px, 2vw, 14px);
        text-align: center;
        white-space: nowrap;
      }
      .buy_area {
        margin: 5px 0;
        display: flex;
        justify-content: space-between;
        .select_box {
          width: 45%;
          &.disabled {
            background-color: #cccccc;
            pointer-events: none;
            opacity: 0.5;
          }
        }
        .purchase-btn{
          // font-size: 13px;
          font-size: clamp(10px, 2vw, 14px);
          width: 50%;
          white-space: nowrap;
        }
      }
      .end-date{
        width: auto;
        max-width: 100%;  // 画面の幅に収まるようにする
        font-size: clamp(10px, 1.8vw, 13px);  // フォントサイズを画面幅に合わせる
        text-align: center;
        color: $baseColor;
      }
    }
  }
}
.sp_pack_title {
  display: none;
}

@media screen and (max-width: $tabletWidth) {
  .banner_base {
    margin: 0;
    width: 100%;
    .image_area{
      .image{
        .gacha_pay {
          font-size: 12px;
          .coin {
            width: 16px;
          }
        }
      }
    }
    .pack_name {
      font-size: 20px!important;
    }
    .pack_detail {
      .code01 {
        width: 80%;
        font-size: 22px!important;
      }
      .code02 {
        height: 100%;
        font-size: 14px!important;
        width: 30%;
        text-align: center;
        margin-top: 5px;
        span {
          display: block;
        }
      }
      .code03 {
        font-size: 14px!important;
        margin-top: 8px!important;
      }
    }
  }
  .countdown {
    font-size: 18px;
    flex-direction: column;
    span.num {
      font-size: 30px;
    }
  }
  .sold_out {
    font-size: 40px;
  }
  .name_area {
    font-size: 80%;
  }
  .sp_pack_title {
    display: flex;
    flex-direction: column;
    text-align: center;
    height: 96px;
    font-size: 22px;
    .red_message {
      font-size: 18px;
      margin-top: 5px;
    }
  }
  .button_area {
    width: 40%;
    .name_area {
      .gacha_content {
        .gacha_bar {
          font-size: 12px;
        }
        .limit_message {
          font-size: 11px;
        }
        .buy_area {
          // margin: 5px 0;
          .select_box {
            width: 45%;
          }
        }
      }
    }
  }
}

@font-face {
  font-family: seven-segment;
  src: url(/fonts/LED7SEG_Standard.ttf)
  format('TrueType')
}
</style>
